/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import {
  Text,
  View,
  StyleSheet,
  Pressable,
  Image,
  Linking,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Toast from 'react-native-toast-message';

import Colors from '~global/Colors';
import ButtonDefault from '../form/Button';
import { updateLegalStatement } from '~store/user/actions/auth';
import { isWeb } from '~global/screens';
import ModalizeBase from './ModalizeBase';
import Checkbox from '../form/Checkbox';

const ModalLegalStatements = () => {
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();

  const modalizeRef = useRef(null);

  const isModalShow = useSelector(
    (state) => state.modal.legalStatements.isShow,
  );
  const data = useSelector((state) => state.modal.legalStatements.data);
  const user = useSelector((state) => state.auth.user);

  const [isAgree, setIsAgree] = useState(false);

  const openHandler = () => {
    modalizeRef.current?.open();
  };

  const closeHandler = () => {
    modalizeRef.current?.close();
  };

  useEffect(() => {
    isModalShow || (user?.isLoggedIn && !user?.is_agree_to_legal_statements)
      ? openHandler()
      : closeHandler();
  }, [isModalShow, user]);

  const setModalHide = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'legalStatements', data });
  };

  const handleAgree = async () => {
    try {
      await dispatch(updateLegalStatement());
    } catch (error) {
      Toast.show({ text1: 'Gagal menyimpan data.' });
    } finally {
      dispatch({
        type: 'SET_USER_DATA',
        data: { is_agree_to_legal_statements: isAgree },
      });

      setModalHide();
      Toast.show({ text1: 'Terima kasih atas persetujuannya.' });
    }
  };

  const handleOpenLink = (title, url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleLinkMail = () => {
    Linking.openURL('mailto:cs@lilla.id');
  };

  return (
    <ModalizeBase
      ref={modalizeRef}
      adjustToContentHeight={true}
      handleStyle={styles.handleStyle}
      modalStyle={styles.modalStyle}
      canClose={false}
      panGestureEnabled={false}>
      <View style={{ ...styles.modalWrapper, paddingBottom: insets.bottom }}>
        <Text
          style={[
            styles.textLarge,
            styles.textPrimaryColor,
            styles.fontBold,
            styles.spacingVertical,
          ]}>
          Perubahan Syarat Ketentuan dan Kebijakan Privasi
        </Text>
        <Text
          style={[
            styles.textMedium,
            styles.textPrimaryColor,
            styles.fontMedium,
            styles.spacingVertical,
          ]}>
          Hi Bestie,
        </Text>
        <Text
          style={[
            styles.textMedium,
            styles.textPrimaryColor,
            styles.fontMedium,
            styles.spacingVertical,
          ]}>
          Sebagai bagian dari komitmen kami dalam melindungi data pribadi Kamu,
          Lilla telah melakukan perubahan pada{' '}
          <Text style={styles.fontBold}>Syarat dan Ketentuan</Text> dan{' '}
          <Text style={styles.fontBold}>Kebijakan Privasi</Text> kami. Dengan
          terus mengakses atau menggunakan situs / aplikasi Lilla, Kamu dianggap
          telah menyetujui kebijakan terbaru tersebut.
        </Text>
        <Text
          style={[
            styles.textMedium,
            styles.textPrimaryColor,
            styles.fontMedium,
            styles.spacingVertical,
          ]}>
          Kami mengimbau agar Kamu membaca dan memahami Syarat dan Ketentuan dan
          Kebijakan Privasi yang baru melalui tautan yang disediakan di bawah
          ini.
        </Text>

        <View style={isWeb ? styles.containerCard : {}}>
          <Pressable
            style={styles.contentCardLink}
            onPress={() =>
              handleOpenLink('Kebijakan Privasi', '/privacypolicy')
            }>
            <Image
              source={require('~assets/img/common/icon-link.png')}
              style={{ width: 24, height: 24, marginRight: 8 }}
              resizeMode="contain"
            />
            <Text
              style={[
                styles.textLarge,
                styles.textPrimaryColor,
                styles.fontBold,
              ]}>
              Baca Kebijakan Privasi
            </Text>
          </Pressable>
          <Pressable
            style={styles.contentCardLink}
            onPress={() =>
              handleOpenLink('Syarat dan Ketentuan', '/termsandconditions')
            }>
            <Image
              source={require('~assets/img/common/icon-link.png')}
              style={{ width: 24, height: 24, marginRight: 8 }}
              resizeMode="contain"
            />
            <Text
              style={[
                styles.textLarge,
                styles.textPrimaryColor,
                styles.fontBold,
              ]}>
              Baca Syarat dan Ketentuan
            </Text>
          </Pressable>
        </View>
        <Pressable style={styles.spacingVertical} onPress={handleLinkMail}>
          <Text
            style={[
              styles.textMedium,
              styles.textPrimaryColor,
              styles.fontMedium,
              styles.spacingVertical,
            ]}>
            Jika Kamu memiliki pertanyaan lebih lanjut, Kamu dapat dapat
            menghubungi{' '}
            <Text style={[styles.fontBold, { color: Colors.purple4 }]}>
              cs@lilla.id
            </Text>
          </Text>
        </Pressable>
        <View style={styles.containerFooter}>
          <View style={styles.contentCardCheckbox}>
            <Checkbox
              checked={isAgree}
              onPress={() => setIsAgree(!isAgree)}
              containerStyle={{ marginRight: 16, marginLeft: -12 }}
            />
            <Text style={styles.textAgree}>
              Dengan menekan tombol di bawah ini, saya menyatakan telah membaca
              dan menyetujui Syarat dan Ketentuan Kebijakan Privasi yang berlaku
              di Lilla.
            </Text>
          </View>
          <ButtonDefault
            title="Saya Setuju"
            disabled={!isAgree}
            disabledStyle={{
              backgroundColor: '#EADEF2',
              borderColor: '#EADEF2',
            }}
            containerStyle={{ marginBottom: 18, marginHorizontal: 16 }}
            onPress={handleAgree}
          />
        </View>
      </View>
    </ModalizeBase>
  );
};

const styles = StyleSheet.create({
  modalWrapper: {
    padding: 16,
  },
  handleStyle: {
    top: 26,
    backgroundColor: Colors.grey0,
    height: 3,
    width: 38,
  },
  modalStyle: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    overflow: 'hidden',
    ...(isWeb ? { width: 600 } : {}),
  },
  textPrimaryColor: {
    color: '#212B36',
  },
  textSecondaryColor: {
    color: '#666565',
  },
  textLarge: {
    fontSize: 16,
    lineHeight: 22,
  },
  textMedium: {
    fontSize: 14,
    lineHeight: 23,
  },
  textSmall: {
    fontSize: 13,
    lineHeight: 20,
  },
  spacingVertical: {
    marginVertical: 8,
  },
  spacingHorizontal: {
    marginHorizontal: 8,
  },
  fontMedium: {
    fontFamily: 'figtree-medium',
  },
  fontBold: {
    fontFamily: 'figtree-bold',
  },
  contentCardLink: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 8,
    backgroundColor: '#FBF4FF',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 8,
    ...(isWeb ? { width: '48%' } : {}),
  },
  containerFooter: {
    backgroundColor: '#FFFBF7',
    marginHorizontal: -16,
  },
  contentCardCheckbox: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 16,
    paddingHorizontal: 16,
    marginHorizontal: 16,
  },
  textAgree: {
    fontFamily: 'figtree-medium',
    fontSize: 13,
    lineHeight: 20,
    color: '#666565',
  },
  containerCard: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export default ModalLegalStatements;
